import { BgType } from '../hooks/useBackgroundEffects'

export const fxItems: BgType[] = [
    {
        label: 'blur.blurBackground',
        deviceId: 'blur',
        key: undefined,
        type: 'option',
        scope: 'public',
    },
    {
        label: 'blur.pulse',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Pulse.jpg',
        key: undefined,
        type: 'option',
        scope: 'public',
    },
    {
        label: 'Network',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Network.jpg',
        key: undefined,
        type: 'option',
        scope: 'public',
    },
    {
        label: 'NetBalls',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/NetBalls.jpg',
        key: undefined,
        type: 'option',
        scope: 'public',
    },
    {
        label: 'Earth',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Earth.jpg',
        key: undefined,
        type: 'option',
        scope: 'public',
    },
    {
        label: 'Dot Network',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Dot-network.jpg',
        key: undefined,
        type: 'option',
        scope: 'public',
    },
    {
        label: 'Creativity',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Creativity.jpg',
        key: undefined,
        type: 'option',
        scope: 'public',
    },
    {
        label: 'Fondo MELI',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Meli-Bg.jpg',
        key: undefined,
        type: 'option',
        scope: [
            '6662246654572e9c2f102199',
            '65a96c12e4af98f8337e3965',
            '673791f564b286620af5f819',
            '673caa6da590de46971b1c78',
        ],
    },
    {
        label: 'Globant Light',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Fondo-Globant-White.jpg',
        key: undefined,
        type: 'option',
        scope: [
            '67a3b03eff46a9771a3f80b6',
            '67a3b367ff46a916063f812e',
            '67a3b482ff46a98bca3f8212',
            '67a3b574ff46a974463f832c',
            '67a3b64cff46a948c93f8335',
            '67a3b82cff46a91ae43f846f',
            '67a3b914ff46a95ff93f8490',
            '67a3b9e7ff46a9707b3f84c3',
            '679b87a2fa5cd252cecefd24',
        ],
    },
    {
        label: 'Globant Dark',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Fondo-Globant-Black.jpg',
        key: undefined,
        type: 'option',
        scope: [
            '67a3b03eff46a9771a3f80b6',
            '67a3b367ff46a916063f812e',
            '67a3b482ff46a98bca3f8212',
            '67a3b574ff46a974463f832c',
            '67a3b64cff46a948c93f8335',
            '67a3b82cff46a91ae43f846f',
            '67a3b914ff46a95ff93f8490',
            '67a3b9e7ff46a9707b3f84c3',
            '679b87a2fa5cd252cecefd24',
        ],
    },
    {
        label: 'SREvolution',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/SREvolution.jpg',
        key: undefined,
        type: 'option',
        scope: [
            '66be2d662552adc2ede2f532',
            '66be39d52552ad0b17e2f68b',
            '66be3b1b2552ad1c75e2f694',
            '66be36002552ad2f38e2f632',
            '66be38172552ad9a39e2f679',
            '66be25e32552ad2f48e2f394',
        ],
    },
    {
        label: 'Meli Shipping',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Meli-Shipping.jpg',
        key: undefined,
        type: 'option',
        scope: [
            '66b3a4514ba55f4667c39e63', 
            '66c3b0ac520920c5aa740308'],
    },
    {
        label: 'Meli Cross Shipping',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/MeliCrossShipping.jpg',
        key: undefined,
        type: 'option',
        scope: [
             '67ace00b080f8148bc37708b',
             '67c996093d708d8647699b6b', 
             '66c3ace55209204dc574029a',
             '66c3aeb2520920cc4b7402fc',
             '66c3a99d520920497774007a',
             '688133d8318621369e9034c9',
             '685188c11ca5bbe552fc332c'],
    },
    {
        label: 'Meli Gen Ia Entrenamiento Práctico',
        deviceId: 'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/meli-genia.jpg',
        key: undefined,
        type: 'option',
        scope: ['67d851e2077195c5a5e87594',
            '6852eab8c545ef566278cec3',
            '6852ef3c484c387631281cd7',
            '6852f032484c389d6c281cea'
        ],
    },
    {
        label: 'Meli Product',
        deviceId: 'https://egg-meet-assets.s3.us-east-1.amazonaws.com/virtual-backgrounds/meliProduct.jpg',
        key: undefined,
        type: 'option',
        scope: ['6851894a1ca5bb4772fc3335'],
    },
    {
        label: 'Meli Workshops cross shipping',
        deviceId:
            'https://d1cs69r9y4gokr.cloudfront.net/virtual-backgrounds/Back_MeLi_Workshops_Cross_Shipping.jpg',
        key: undefined,
        type: 'option',
        scope: ['66c3b1ed5209207b5f740311'],
    },
    {
        label: 'Meli Performance Hands-on',
        deviceId:
            'https://egg-meet-assets.s3.us-east-1.amazonaws.com/virtual-backgrounds/meli-performance-handson-bg.jpg',
        key: undefined,
        type: 'option',
        scope: ['685188071ca5bb6e98fc3323','685186fc1ca5bbf204fc331a' ],
    },
    {
        label: 'Meli Gen Ai Hands-on',
        deviceId:
            'https://egg-meet-assets.s3.us-east-1.amazonaws.com/virtual-backgrounds/genia-hans-on.jpg',
        key: undefined,
        type: 'option',
        scope: ['6851859e1ca5bb7f8ffc324f'],
    },
    {
        label: 'blur.disable',
        deviceId: 'disable-effect',
        key: undefined,
        type: 'option',
        scope: 'public',
    },
]
